import { render, staticRenderFns } from "./TreeWater.vue?vue&type=template&id=40a37978&"
import script from "./TreeWater.vue?vue&type=script&lang=js&"
export * from "./TreeWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports